import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_FIELD_AGENCY_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_PHONE,
  PRE_ACTIVATION_FIELD_BUSINESS_NAME,
  PRE_ACTIVATION_FIELD_EMAIL,
  PRE_ACTIVATION_FIELD_FULL_NAME,
  PRE_ACTIVATION_FIELD_JOB_TITLE,
  PRE_ACTIVATION_FIELD_WEBSITE_URL,
  PRE_ACTIVATION_FIELD_WHATSAPP,
  PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE,
  PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL,
  PRE_ACTIVATION_PLACEHOLDER_WHATSAPP,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import PersonFields from "../components/PersonFields";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";
import TextFieldBlock from "../components/TextFieldBlock";

const ContactSection = ({ control, errors, readOnly, isAgency = false }) => {
  const { t } = useTranslation();

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <TextFieldBlock
        name="fullName"
        label={t(PRE_ACTIVATION_FIELD_FULL_NAME)}
        placeholder={t(PRE_ACTIVATION_PLACEHOLDER_FULL_NAME)}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
      <TextFieldBlock
        name="email"
        label={t(PRE_ACTIVATION_FIELD_EMAIL)}
        placeholder={t(PRE_ACTIVATION_PLACEHOLDER_EMAIL)}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        type="email"
      />
      {isAgency ? (
        <TextFieldBlock
          name="jobTitle"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE)}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE)}
          required
          control={control}
          errors={errors}
          readOnly={readOnly}
        />
      ) : null}
      {isAgency ? (
        <TextFieldBlock
          name="whatsApp"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_PHONE)}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE)}
          required
          control={control}
          errors={errors}
          readOnly={readOnly}
          type="text"
        />
      ) : null}
      <TextFieldBlock
        name="businessName"
        label={t(
          isAgency
            ? PRE_ACTIVATION_FIELD_AGENCY_NAME
            : PRE_ACTIVATION_FIELD_BUSINESS_NAME
        )}
        placeholder={t(
          isAgency
            ? PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME
            : PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME
        )}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
      {isAgency ? (
        <FieldBlock>
          <FieldLabel
            text={t(PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT)}
            required
          />
          <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT)} />
          <PersonFields
            prefix="backupContact"
            control={control}
            errors={errors}
            readOnly={readOnly}
            hideFieldLabels
          />
        </FieldBlock>
      ) : null}
      {isAgency ? (
        <FieldBlock>
          <FieldLabel
            text={t(PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT)}
            required
          />
          <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT)} />
          <PersonFields
            prefix="leadershipContact"
            control={control}
            errors={errors}
            readOnly={readOnly}
            hideFieldLabels
            showEmail={false}
          />
        </FieldBlock>
      ) : null}
      {!isAgency ? (
        <>
          <TextFieldBlock
            name="jobTitle"
            label={t(PRE_ACTIVATION_FIELD_JOB_TITLE)}
            placeholder={t(PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE)}
            required
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
          <TextFieldBlock
            name="whatsApp"
            label={t(PRE_ACTIVATION_FIELD_WHATSAPP)}
            placeholder={t(PRE_ACTIVATION_PLACEHOLDER_WHATSAPP)}
            required
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
          <TextFieldBlock
            name="websiteUrl"
            label={t(PRE_ACTIVATION_FIELD_WEBSITE_URL)}
            placeholder={t(PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL)}
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
        </>
      ) : null}
    </ReadOnlySectionGrid>
  );
};

export default ContactSection;
